/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Usage_Data_On_PremiseInputs */



/**
* | output |
* | --- |
* | "Keep sensitive data on-premise" |
*
* @param {Onboarding_Usage_Data_On_PremiseInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_usage_data_on_premise = /** @type {((inputs?: Onboarding_Usage_Data_On_PremiseInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Usage_Data_On_PremiseInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sensible Daten on-premise halten")
	return /** @type {LocalizedString} */ ("Keep sensitive data on-premise")
});